const Login = () => import("@/components/Auth/Login");
const Forgot = () => import("@/components/Auth/Forgot");
const ResetConfirm = () => import("@/components/Auth/ResetConfirm");
const UpdatePassword = () => import("@/components/Auth/UpdatePassword");
const LoggedOut = () => import("@/components/Auth/LoggedOut");

const routes = [
  {
    name: "Home",
    path: "/",
    redirect: {
      name: "ProjectIndex"
    },
    meta: {
      title: "Home",
      sidebar: true
    }
  },
  {
    name: "LoggedOut",
    path: "/loggedout",
    component: LoggedOut,
    meta: {
      title: "Logged out due to inactivity",
      sidebar: false,
      public: false
    }
  },
  {
    name: "Login",
    path: "/login",
    component: Login,
    meta: {
      title: "Login to Mynd",
      sidebar: false,
      public: true
    }
  },
  {
    name: "Forgot",
    path: "/forgot",
    component: Forgot,
    meta: {
      title: "Forgot Password",
      sidebar: false,
      public: true
    }
  },
  {
    name: "ResetConfirm",
    path: "/reset-password",
    component: ResetConfirm,
    meta: {
      title: "Reset Password Confirmation",
      sidebar: false,
      public: true
    }
  },
  {
    name: "UpdatePassword",
    path: "/update-password",
    component: UpdatePassword,
    meta: {
      title: "Update password",
      sidebar: false,
      public: true
    }
  }
];

export default routes;
